import OutOfOrderModal from './OutOfOrderModal.vue';

export default OutOfOrderModal;
